import React, { Component } from 'react';
import withRouter from './Common/withRouter';
// import { withRouter } from "react-router-dom";

class NonAuthLayout extends Component {
    constructor(props) {
        super(props);
        this.state={};
        this.capitalizeFirstLetter.bind(this);
    }
    
    capitalizeFirstLetter = string => {
        return string.charAt(1).toUpperCase() + string.slice(2);
      };

    updatePageMetadata = () => {
        const pathname = this.props.router.location.pathname;
        const pageMetadata = {
            "/login": {
                title: "Login | Access to Manage Your Ads",
                description: "Sign in to iAuto Marketplace to manage your ad listing.",
            },
            "/register": {
                title: "User Registration | Join and Manage Your Ads in iAuto Marketplace",
                description: "Register an Account in iAuto Marketplace to manage your ad listing.",
            },
        };
        const metadata = pageMetadata[pathname];

        if (metadata) {
            document.title = metadata.title;

            let descriptionMeta = document.querySelector('meta[name="description"]');
            if (!descriptionMeta) {
                descriptionMeta = document.createElement("meta");
                descriptionMeta.setAttribute("name", "description");
                descriptionMeta.setAttribute("data-iauto-page-metadata", "true");
                document.head.appendChild(descriptionMeta);
            }
            descriptionMeta.setAttribute("content", metadata.description);
            return;
        }

        let currentPage = this.capitalizeFirstLetter(pathname);
        currentPage = currentPage.replaceAll("-", " ");
        document.title = currentPage + " | iAuto";
        document.querySelector('meta[data-iauto-page-metadata="true"]')?.remove();
    };

    componentDidMount() {
        this.updatePageMetadata();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.router.location.pathname !== this.props.router.location.pathname) {
            this.updatePageMetadata();
        }
    }

    componentWillUnmount() {
        document.querySelector('meta[data-iauto-page-metadata="true"]')?.remove();
    }
    render() {
        return <React.Fragment>
            {this.props.children}
        </React.Fragment>;
    }
}

export default (withRouter(NonAuthLayout));
